


import { IConfigAssets, IConfigRoute } from '../interface/config';
import { IFetcher, injectLog } from '../interface/util';

const DEFAULTS: IConfigAssets = {
    static: {
        flags: {
            AD  : 'img/asset/flags/ad.png',
            AR  : 'img/asset/flags/ar.png',
            BE  : 'img/asset/flags/be.png',
            BG  : 'img/asset/flags/bg.png',
            BP  : 'img/asset/flags/bp.png',
            BSL : 'img/asset/flags/bsl.png',
            CS  : 'img/asset/flags/cs.png',
            DE  : 'img/asset/flags/de.png',
            EN  : 'img/asset/flags/en.png',
            ES  : 'img/asset/flags/es.png',
            FI  : 'img/asset/flags/fi.png',
            FR  : 'img/asset/flags/fr.png',
            GD  : 'img/asset/flags/gd.png',
            GL  : 'img/asset/flags/gl.png',
            GR  : 'img/asset/flags/gr.png',
            HU  : 'img/asset/flags/hu.png',
            IS  : 'img/asset/flags/is.png',
            IT  : 'img/asset/flags/it.png',
            JA  : 'img/asset/flags/ja.png',
            KO  : 'img/asset/flags/ko.png',
            LT  : 'img/asset/flags/lt.png',
            NL  : 'img/asset/flags/nl.png',
            NO  : 'img/asset/flags/no.png',
            PL  : 'img/asset/flags/pl.png',
            PT  : 'img/asset/flags/pt.png',
            RO  : 'img/asset/flags/ro.png',
            RU  : 'img/asset/flags/ru.png',
            SE  : 'img/asset/flags/se.png',
            SH  : 'img/asset/flags/sh.png',
            ZH  : 'img/asset/flags/zh.png',
        },
    },
    pwa: {
        images: {
            icon512: '',
        },
        themeColor: '#fff',
        backgroundColor: '#000',
        name: 'Workspace',
    }
}

interface AppManifest {
    short_name: string;
    name: string;
    icons: [{src: string, sizes: string, type: string}],
    start_url: string,
    display: string;
    theme_color: string;
    background_color: string;
}

function load(fetcher: IFetcher, routing: IConfigRoute): Promise<IConfigAssets> {
    return new Promise(async function(resolve, reject) {
        try {
            const pathFetch = `${routing.basename}/manifest.json`.replace(/\/+/g, '/'); /* get the base url from config, append /manifest.json & remove double slashes '//' */
            const manifest = await fetcher<AppManifest>({
                url: pathFetch,
                method: 'GET',
                expectedResponseType: 'json'});

            let exports: IConfigAssets = {...DEFAULTS};

            exports.pwa.themeColor = manifest.payload?.theme_color || exports.pwa.themeColor;
            exports.pwa.backgroundColor = manifest.payload?.background_color || exports.pwa.backgroundColor;
            exports.pwa.images.icon512 = manifest.payload?.icons[manifest.payload?.icons.length -1].src || exports.pwa.images.icon512;
            exports.pwa.name = manifest.payload?.name || exports.pwa.name;

            resolve(exports);
        } catch (error) {
            const log = injectLog();
            log.error(`Asset fetch failed: ${JSON.stringify(error)}`);
            reject(error);
        }
    });
}

export default load